var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupChatFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2630_139089)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2630_139089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1C3.45 1 3 1.45 3 2L3 8.24609C3 8.52409 3.3372 8.6628 3.5332 8.4668L5 7L13 7C13.55 7 14 6.55 14 6V2C14 1.45 13.55 1 13 1L4 1ZM16 2V6C16 6.771 15.6997 7.468 15.2207 8H19L20.4707 9.4707C20.6657 9.6657 21 9.52795 21 9.25195V3C21 2.45 20.55 2 20 2H16ZM12 10C11.2044 10 10.4413 10.3161 9.87868 10.8787C9.31607 11.4413 9 12.2044 9 13C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13C15 12.2044 14.6839 11.4413 14.1213 10.8787C13.5587 10.3161 12.7956 10 12 10ZM6 12C5.46957 12 4.96086 12.2107 4.58579 12.5858C4.21071 12.9609 4 13.4696 4 14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16C6.53043 16 7.03914 15.7893 7.41421 15.4142C7.78929 15.0391 8 14.5304 8 14C8 13.4696 7.78929 12.9609 7.41421 12.5858C7.03914 12.2107 6.53043 12 6 12ZM18 12C17.4696 12 16.9609 12.2107 16.5858 12.5858C16.2107 12.9609 16 13.4696 16 14C16 14.5304 16.2107 15.0391 16.5858 15.4142C16.9609 15.7893 17.4696 16 18 16C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14C20 13.4696 19.7893 12.9609 19.4142 12.5858C19.0391 12.2107 18.5304 12 18 12ZM12.0039 16.9688C8.58491 16.9688 6.00781 18.4794 6.00781 20.4844V22C6.00781 22.552 6.45581 23 7.00781 23H17C17.552 23 18 22.552 18 22V20.4844C18 18.4804 15.4219 16.9688 12.0039 16.9688ZM19.0723 17.7813C19.6683 18.5662 20 19.4824 20 20.4844V23H22.125C22.677 23 23.125 22.552 23.125 22V20.7695C23.125 19.2435 21.4403 18.0483 19.0723 17.7813ZM4.91992 17.8008C2.62292 18.0978 1 19.2725 1 20.7695L1 22C1 22.552 1.448 23 2 23H4.00781V20.4844C4.00781 19.4904 4.33292 18.5818 4.91992 17.8008Z",
    fill: "#0044C6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2630_139089",
    x: -23,
    y: -11,
    width: 70.125,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2630_139089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2630_139089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2630_139089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChatFigma);
export default __webpack_public_path__ + "static/media/group-chat-figma.9adbd47bf7509877f440f0da4dca384d.svg";
export { ForwardRef as ReactComponent };